import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimeUtils } from 'src/app/lib/date-time-utils';
import { SubscribedComponent } from 'src/app/lib/subscribed.component';
import { watchEntity } from 'src/app/lib/entity-watcher.util';
import { buildScheduleDisplay, FormattedScheduleGroup } from 'src/app/lib/location-schedule';
import { Location } from 'src/app/models/location.model';
import { LocationService } from '@services/location.service';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-location-schedule',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './location-schedule.component.html',
  imports: [TranslateModule, NzDividerModule, NzTypographyComponent],
  standalone: true,
})
export class LocationScheduleComponent extends SubscribedComponent implements OnInit {
  formattedSchedule: FormattedScheduleGroup[] = [];
  location?: Location;
  private currentLocationUuid?: string;

  constructor(
    private locationService: LocationService,
    private dateTimeUtils: DateTimeUtils,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.updateLocation(this.locationService.getLocation());
    watchEntity(this.locationService.locationChanged, this.destroyed$, (location) => {
      this.updateLocation(location);
    });
  }

  private updateLocation(location: Location): void {
    this.location = location;

    if (!location?.uuid || this.currentLocationUuid === location.uuid) {
      this.cdRef.markForCheck();
      return;
    }

    this.currentLocationUuid = location.uuid;
    void this.loadSchedule(location);
  }

  private async loadSchedule(location: Location): Promise<void> {
    const schedule = await firstValueFrom(this.locationService.fetchSchedule(location.uuid));
    const firstDayOfWeek = this.dateTimeUtils.getWeekStartForCountry(location.countryCode);
    this.formattedSchedule = buildScheduleDisplay(schedule, firstDayOfWeek);
    this.cdRef.markForCheck();
  }
}
